import React, { useContext } from 'react'
import { UserContext } from '../../App'
import p1 from '../../assets/edits/P-1.png';
import p2 from '../../assets/edits/P-2.png';
import p3 from '../../assets/edits/P-3.png';
import { IoChevronBackCircleSharp } from "react-icons/io5";

import './edits.css';
import { Link } from 'react-router-dom';


function Photoedit() {
    const {theme,setTheme}=useContext(UserContext);
  return (
    <>

    <div style={{paddingTop:"5rem"}}  className={theme==0?'pedits-light':'pedits-dark'}>
        <center className={theme==0?'name-light':'name-dark'}><Link to="/services"><IoChevronBackCircleSharp/>Photo Editing</Link></center>
       <main className='photo-item-list'>
        <img src={p1} alt="phto-1" />
        <img src={p2} alt="phto-2" />
        <img src={p3} alt="phto-3" />
       </main>
    <div>
    </div>
  </div>
  </>
  )
}

export default Photoedit